import { connect } from 'react-redux';
import { compose } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import { accountSetup } from 'src/app/state/actions/account';
import { pushNextCheckoutState } from 'src/app/state/actions/checkout';
import { getPathParams } from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import Renderer from '.';

function makeMapStateToProps() {
  return ownProps => {
    const cartId = getPathParams(ownProps, 'cartId');

    return {
      cartId,
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchAccountSetup: ({ email, password }) => dispatch(accountSetup(email, password)),
  dispatchPushNext: async () => await dispatch(pushNextCheckoutState()),
});

const Account = compose(errorBoundary, connect(makeMapStateToProps, mapDispatchToProps))(Renderer);

export default Account;
